import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss']
})
export class FieldErrorComponent {

  @Input() formField: any;

  _messages = ['This is required field'];

  @Input('error')
  set messages(value: any) {
    if (value) {
      this._messages = value;
    }
  }

  get messages() {
    return this._messages;
  }
}
